var e={name:"chat-online-indicator",props:{size:{type:String,default:"14px"},active:{type:Boolean,default:!0}},computed:{classes:function(){return{"chat-online-indicator--online":this.active}}}};export{e as default};
